export enum MaxioComponent {
  askQuestions = "questions_asked",
  createDueDiligenceProject = "project_runs",
  scorecardReport = "scorecard_report",
  investmentReport = "investment_report",
}
